import setUiMessage from '../../Utilities/Tostify';
import { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import PatAppRow from './PatAppRow';
import { useSelector } from 'react-redux';

function PatAppointment({ patientId }) {
  const { user } = useSelector((state) => state.auth);
  const { globalReload } = useSelector((state) => state.app);
  const [allData, setAllData] = useState(null);
  const [resource, setResource] = useState('');
  const [supervisor, setSupervisor] = useState('');
  const [tov, setAllTovs] = useState('');
  const [location, setLocation] = useState('');
  const [appDateTime, setappDateTime] = useState('');

  //const [specAppStatus, setSpecAppStatus] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const response = await post('api/auth/getPatientAppList', {
          patientId: patientId,
          appDateTime: appDateTime,
          resource: resource,
          superVisor: supervisor,
          tov: tov,
          location: location,
          loginUserId: user?.id,
        });

        if (response.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err?.message);
      }
    })();
  }, [
    patientId,
    user?.id,
    appDateTime,
    resource,
    supervisor,
    tov,
    location,
    globalReload,
  ]);

  function handleResource(e) {
    setResource(e.target.value);
  }

  function handleSupervisor(e) {
    setSupervisor(e.target.value);
  }

  function handletov(e) {
    setAllTovs(e.target.value);
  }

  function handleLocation(e) {
    setLocation(e.target.value);
  }

  function handleSearch(e) {
    setappDateTime(e.target.value);
  }

  //CHECK

  return (
    <div id="pat-appt-main-scrn" className="preauth-Maingrid-Pat">
      <div className="c-mid-bdy-hdr clear-top10">
        <span className="widget-hdr-title bold clear-top">Appointments:</span>
        <span className="actn-yes" style={{ width: 'unset' }}>
          Add New
        </span>
      </div>
      <div className="preauth-Maingrid-Patbdy grid-sec clear-top10">
        <div className="preauth-Maingrid-Pat-hdr grid-sec">
          <div className="preauth-Maingrid-Pat-sbhdr flex-sec">
            <span className="pacolm1">Appointment</span>
            <span className="pacolm5">Resource</span>
            <span className="pacolm5">Supervisor</span>
            <span className="pacolm4">Type of visit</span>
            <span className="pacolm4">Status</span>
            <span className="pacolm1">Location</span>
            <span className="pacolm4">Action</span>
            <span className="pacolm4">Reason for visit</span>
          </div>
          <div className="preauth-Maingrid-Pat-sbhdr flex-sec">
            <span className="pacolm1">
              <input
                type="text"
                className="inpt-width-nw width100"
                placeholder="Search here..."
                onChange={handleSearch}
              />
            </span>

            <span className="pacolm5">
              <select
                className="inpt-width-nw"
                value={resource}
                onChange={handleResource}
              >
                <option value="">Select Resource</option>
                {allData?.allResource &&
                  allData?.allResource.map((data, i) => {
                    return (
                      <option key={i} value={data.id}>
                        {data.resName}
                      </option>
                    );
                  })}
              </select>
            </span>

            <span className="pacolm5">
              <select
                className="inpt-width-nw"
                value={supervisor}
                onChange={handleSupervisor}
              >
                <option value="">Select Supervisor</option>
                {allData?.allProvider &&
                  allData?.allProvider.map((data, i) => {
                    return (
                      <option key={i} value={data.id}>
                        {data.proName}
                      </option>
                    );
                  })}
              </select>
            </span>

            <span className="pacolm4">
              <select
                className="inpt-width-nw"
                value={tov}
                onChange={handletov}
              >
                <option value="">Select visit type</option>
                {allData?.allTov &&
                  allData?.allTov.map((data, i) => {
                    return (
                      <option key={i} value={data.id}>
                        {data.visit_type}
                      </option>
                    );
                  })}
              </select>
            </span>

            <span className="pacolm4">&nbsp;</span>

            <span className="pacolm1">
              <select
                className="inpt-width-nw"
                value={location}
                onChange={handleLocation}
              >
                <option value="">Select location</option>
                {allData?.allLocation &&
                  allData?.allLocation.map((data, i) => {
                    return (
                      <option key={i} value={data.id}>
                        {data.location_code}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="pacolm4">&nbsp;</span>
            <span className="pacolm4">&nbsp;</span>
          </div>
        </div>
        <div className="preauth-Maingrid-Pat-sb-bdy grid-sec">
          {allData?.appList &&
            allData?.appList.map((data, i) => {
              return (
                <div
                  key={i}
                  className={`preauth-Maingrid-Pat-bdy-rw flex-sec ${
                    i % 2 !== 0 ? 'alt-rw ' : ''
                  }`}
                >
                  <PatAppRow data={data} />
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
export default PatAppointment;
